import React, { ReactElement } from "react";

export enum typeOfFilter {
  input = "input",
  date = "date",
  indication = "indication",
  statusSelect = "statusSelect",
  offenceSelect = "offenceSelect",
  tagsSelect = "tagsSelect",
  decisionSelect = "decisionSelect",
  rejectionReasonSelect = "rejectionReasonSelect",
}

export type tableColumns = {
  Header: string;
  accessor: string;
  Cell?: ({ cell }: { cell: any }) => ReactElement;
  type?: typeOfFilter;
};
